import { assetFor } from '@runtime/core/theme/assets'
import styles from './CoachTileReference.module.scss'

type CoachTileReferenceProps = {
  tile: string
  rotation?: number
  label: string
}

export default function CoachTileReference({ tile, rotation, label }: CoachTileReferenceProps) {
  const normalizedRotation = typeof rotation === 'number' ? rotation : 0
  return (
    <span className={styles.reference} role="img" aria-label={label} title={label}>
      <img
        src={assetFor(tile)}
        className={styles[`rotation${normalizedRotation}`]}
        alt=""
        data-coach-tile={tile}
        data-rotation={rotation}
      />
    </span>
  )
}
